const api = '/api/v1/m001_r_category_controller.php';
import axios from 'axios';
export const category_repository =  {
    get(data){
        return  axios.get(api,data);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

